import React from "react";
import { useNavigate } from "react-router-dom";
/* Components */
import CardHistory from "./cardHistory";

const CardHistoryList = ({ cardsData }) => {
  const navigate = useNavigate();

  return (
    <div className={`cards-group-history${cardsData.length > 4 ? ' cards-start' : ''}`}>
      {cardsData.map((cardData, index) => (
        <CardHistory key={index} {...cardData} onClick={() => navigate(`${cardsData[index].link}`)}/>
      ))}
    </div>
  );
}

export default CardHistoryList;